import React from "react";
import classNames from "classnames";
import Icon, { Icons } from "./Icon";

const Working = ({ className, title }: { className: string; title?: string }) => (
    <Icon title={title} icon={Icons.REFRESH} className={classNames("inline-block icon-spin", className)} />
);
export default Working;
